import {$qs, onWindowMessage} from '../../../@shared/ts/dom';
import {type ButtonClickedMessage} from '../../../@type/window-messages';
import {Environment} from '../reducers/environmentReducer';
import {MerchantConfiguration} from '../reducers/merchantConfigurationReducer';

export function initMetrics() {
	// Pay button metrics
	$qs('#pp-pay')?.addEventListener('click', () => {
		recordNonPPButtonClick('pp-pay');
	});
	$qs('#pp-pay-mobile')?.addEventListener('click', () => {
		recordNonPPButtonClick('pp-pay-mobile');
	});

	// Continue button metrics
	$qs('#pp-continue-to-shipping')?.addEventListener('click', () => {
		recordNonPPButtonClick('pp-continue-to-shipping');
	});
	$qs('#pp-continue-to-shipping-mobile')?.addEventListener('click', () => {
		recordNonPPButtonClick('pp-continue-to-shipping-mobile');
	});

	// Plugin button metrics
	onWindowMessage<ButtonClickedMessage>('buttonClicked', message => {
		// Button Metrics Lambda API trigger with a buttonClicked Event Type
		recordButtonClick(buttonTypeValidation(message.buttonID), getPPButtonLocation(message));
	});
}

export function buttonTypeValidation(buttonType: string | undefined): string {
	return buttonType ?? 'unknown';
}

// Used to record clicks that aren't pp-button / pp-button-mini
export function recordNonPPButtonClick(buttonType: string) {
	recordButtonClick(buttonType, PPButtonLocation.NotApplicable);
}

export function recordButtonClick(buttonType: string, ppButtonLocation: PPButtonLocation) {
	postButtonMetrics({
		domain: MerchantConfiguration.hostName(),
		buttonType,
		ppButtonLocation,
		isMobile: Environment.customer.mobile(),
		isTestMode: Environment.testMode(),
	});
}

export enum PPButtonLocation {
	Product = 'product',
	Checkout = 'checkout',
	MiniCart = 'mini-cart',
	Cart = 'cart',
	NotApplicable = 'not-applicable',
}

export function getPPButtonLocation(message: ButtonClickedMessage): PPButtonLocation {
	if (message.isMiniCart) {
		return PPButtonLocation.MiniCart;
	}

	switch (Environment.plugin.pageType()) {
		case ('cart'):
			return PPButtonLocation.Cart;
		case ('checkout'):
			return PPButtonLocation.Checkout;
		case ('product'):
			return PPButtonLocation.Product;
		default:
			return PPButtonLocation.NotApplicable;
	}
}

export type ButtonMetricOptions = {
	domain: string;
	buttonType: string;
	ppButtonLocation: PPButtonLocation;
	isMobile: boolean;
	isTestMode: boolean;
};

export function postButtonMetrics(options: ButtonMetricOptions) {
	if (!options.isTestMode) {
		// Promise .then/.catch used to prevent any potential blocking.
		fetch(
			`https://2fad6w3exg.execute-api.us-east-1.amazonaws.com/v1/buttonstats?domain=${options.domain}&buttonType=${options.buttonType}&ppButtonLocation=${String(options.ppButtonLocation)}&isMobile=${
				String(options.isMobile)
			}&isProductionData=${String(isProductionDomain(options.domain))}`,
		).then(() => {
			// It worked!
		}).catch(() => {
			// Do no harm.
		});
	}
}

export function isProductionDomain(domain: string): boolean {
	switch (domain) {
		case ('localhost'):
		case ('127.0.0.1'):
		case ('store.local'):
		case ('woo.store.local'):
		case ('woo.peachpay.app'):
		case ('theme1.peachpay.app'):
		case ('theme2.peachpay.app'):
		case ('theme3.peachpay.app'):
		case ('theme4.peachpay.app'):
		case ('theme5.peachpay.app'):
		case ('qa.peachpay.app'):
		case ('demo.peachpay.app'):
		case ('ui-test.peachpay.app'):
			return false;
		default:
			return true;
	}
}
